import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseB2BOrderReport() {
  const MyAxios = UseCustomAxios();

  const GetB2BOrderReport = (myPC, search, year, month, callback, bool) => {
    MyAxios.get(
      `Admin_Marketing_B2BOrderReport?w=${search}&y=${year}&m=${month}`,
      {
        headers: {
          IsPage: bool,
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetB2BOrderReport,
  };
}
